// Module
var code = " <div ng-bind=\"$ctrl.gbWidget.widget.text\"></div> ";
// Exports
export default code;